import { ProductAddonGroupDetailPage } from '@/features/product-addon-group/pages/ProductAddonGroupDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-addon-group/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_addon_group.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAddonGroupDetailPage,
})
